import React from "react";

const ApplicationsList = (props) => {

    return (
        <div>
            {props.applicants.length === 0 ? (
                <p>No applicants found.</p>
            ) : (
                <ul className="admin-ul">
                    <h3>Applicants</h3>
                   <li className="list-item header">
                            <div>
                                <p>Applicant</p>
                                <p>Status</p>
                            </div>
                    </li>
                    {props.applicants.map((applicant) => (
                        <li className="list-item form-group inline" key={applicant._id} onClick={() => props.onShowApplicantDetails(applicant)}>
                            <div>{applicant.name}</div>
                            <div>
                                <span className={`badge ${applicant.status}`}>{applicant.status}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default ApplicationsList;